import script from "./DiamondCertificateDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./DiamondCertificateDetails.vue?vue&type=script&lang=ts&setup=true"

import "./DiamondCertificateDetails.vue?vue&type=style&index=0&id=6568fb7e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6568fb7e"]])

export default __exports__